import RolePermissionsForm from '@app/components/apps/Users/UserRolesForm';
import { Col, Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';

const CreateUserRolePage = () => {
  const routes = [
    {
      path: '/user-roles',
      breadcrumbName: 'User Roles',
    },
    {
      path: '/add-role',
      breadcrumbName: 'Add User Role',
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <BaseBreadcrumbWithRender routes={routes} separator=">" />
      </Col>
      <RolePermissionsForm editable={true} pageTitle={''} type={'create'} />
    </Row>
  );
};

export default CreateUserRolePage;
